<div>
  <Navbar />
  <Sidebar />

  <div class="page-wrapper aic-mobile-content main-settings-page d-lg-none">
    <div class="hero-section w-100 aic-safe-bottom">
      <main class="admin-mobile-settings w-100">
        <section class="card border-0 shadow-sm rounded-4 overflow-hidden admin-mobile-profile mb-3 mb-md-4">
          <div class="card-body p-3 p-md-4">
            <div class="d-flex align-items-center gap-3">
              <div class="admin-mobile-avatar d-flex align-items-center justify-content-center">
                {{ user_initials }}
              </div>
              <div class="min-w-0 flex-grow-1">
                <h2 class="h5 fw-bold mb-1 text-truncate">{{ user_display_name }}</h2>
                <p class="small text-muted mb-2 text-truncate">{{ user_email }}</p>
                <div class="d-flex align-items-center gap-2 flex-wrap">
                  <span class="badge rounded-pill admin-role-badge">{{ user_role_label }}</span>
                  <span class="badge rounded-pill text-bg-success">Active</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        <button
          v-if="show_company_warning"
          type="button"
          class="admin-profile-warning btn w-100 text-start d-flex align-items-start gap-3 mb-3 mb-md-4 shadow-sm"
          @click="go_to_profile"
        >
          <span class="admin-warning-icon d-inline-flex align-items-center justify-content-center">
            <i class="fa-solid fa-triangle-exclamation" aria-hidden="true"></i>
          </span>
          <span class="flex-grow-1">
            <span class="d-block fw-bold">Company profile incomplete</span>
            <span class="d-block small">Complete your organization profile before provisioning users.</span>
          </span>
          <i class="fa-solid fa-chevron-right mt-1" aria-hidden="true"></i>
        </button>

        <section
          v-for="section in admin_sections"
          :key="section.title"
          class="card border-0 shadow-sm rounded-4 overflow-hidden mb-3 mb-md-4"
        >
          <div class="card-header bg-white border-bottom px-3 px-md-4 py-3">
            <h3 class="h6 fw-bold mb-0">{{ section.title }}</h3>
          </div>

          <div class="list-group list-group-flush">
            <button
              v-for="item in section.items"
              :key="item.label"
              type="button"
              class="list-group-item list-group-item-action d-flex align-items-center gap-3 py-3 px-md-4"
              @click="go_to_admin_target(item.target)"
            >
              <span class="admin-menu-icon d-inline-flex align-items-center justify-content-center" :class="item.class">
                <i :class="item.icon" aria-hidden="true"></i>
              </span>
              <span class="min-w-0 flex-grow-1 text-start">
                <span class="d-block fw-semibold text-truncate">{{ item.label }}</span>
                <span class="d-block small text-muted text-truncate">{{ item.subtitle }}</span>
              </span>
              <i class="fa-solid fa-chevron-right text-muted small" aria-hidden="true"></i>
            </button>
          </div>
        </section>
      </main>
    </div>
  </div>
</div>
